<mat-card>
  <div [formGroup]="orderForm">

    <button (click)="addPoint()">Adicionar Coordenada</button>

    <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;">
      <div [formGroupName]="i">

        <mat-form-field>
          <input matInput type="number" formControlName="value" placeholder="value">
        </mat-form-field>

        <mat-form-field>
          <input matInput type="number" formControlName="X" placeholder="X">
        </mat-form-field>

        <mat-form-field>
        <input matInput type="number" formControlName="Y" placeholder="Y">
        </mat-form-field>

        <button mat-icon-button (click)="removeItem(i)">
            <mat-icon aria-label="Remover item">remove_circle</mat-icon>
          </button>


      </div>

    </div>

  </div>

</mat-card>